export default "__VITE_ASSET__DHTR1O1I__"